export default {
    data() {
        return {
            loadings: {},
        }
    },
}
